export const ThumbInputVariant = {
    base: 'base',
    subtle: 'subtle',
};
//# sourceMappingURL=types.js.map